import { useStore } from 'src/contexts/StoreContext';
import { observer } from 'mobx-react-lite';
import { SaveChangesIcon } from 'src/images/SaveChangesIcon';
import { useState } from 'react';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import BaseModal from '../../base-modal/BaseModal';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import { parseAnalyticsParamsByPreview } from 'src/_shared/analytics.utils';

export const ModalSaveChanges = observer(
  ({
    type,
    dynamicModalVisible,
    dynamicModalLayer: { onPressDiscardChanges, onPressSaveChanges, id },
  }: DynamicModalProps) => {
    const {
      i18n,
      project: { activePreview },
      dynamicModal: { closeModal },
    } = useStore();

    const [isSavingChanges, setIsSavingChanges] = useState(false);

    const handleDiscard = () => {
      onPressDiscardChanges();
      amplitude.trackEvent(AnalyticsEvents.modifyPhoto.unsavedChangesClick, {
        ...parseAnalyticsParamsByPreview(activePreview),
        action: 'discard',
      });
    };
    const handleSave = () => {
      setIsSavingChanges(true);
      onPressSaveChanges();
      amplitude.trackEvent(AnalyticsEvents.modifyPhoto.unsavedChangesClick, {
        ...parseAnalyticsParamsByPreview(activePreview),
        action: 'save',
      });
    };

    return (
      <BaseModal
        testID={TestIDs.SAVE_CHANGES}
        modalIcon={<SaveChangesIcon />}
        title={i18n.t('modal-save-changes:title')}
        description={i18n.t('modal-save-changes:description')}
        confirmText={isSavingChanges ? i18n.t('modal-save-changes:saving') : i18n.t('modal-save-changes:save')}
        discardText={i18n.t('modal-save-changes:discard')}
        handleConfirm={handleSave}
        handleDiscard={handleDiscard}
        showLoader={isSavingChanges}
        onClose={closeModal}
        onCloseOutside={closeModal}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
